export default __webpack_public_path__ + "static/media/black-identify-pan-icon.8a3543f0.svg";